import React, { useState, useEffect, useCallback } from 'react';
import Toggle from 'react-toggle';
import getPath from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { FlexDiv } from '../../../../styles/styled';
import { soundcastManager } from '../../../../helpers/managers';

const DisplayRatings = props => {
  const { soundcast } = props;
  if (isEmpty(soundcast)) {
    return null;
  }

  const { soundcastId, published = false, landingPage = false } = soundcast;
  const isPrivate = published && !landingPage;
  const [displayRatings, setDisplayRatings] = useState(false);

  useEffect(() => {
    soundcastManager.getProp(soundcastId, 'displayRatings', false).then(value => {
      console.log('setDisplayRatings', value);
      setDisplayRatings(value);
    });
  }, [soundcastId]);

  const onChangeDisplayRating = useCallback(async () => {
    setDisplayRatings(odisplayRatings => {
      const displayRatings = !odisplayRatings;
      soundcastManager.update(soundcastId, { displayRatings });
      return displayRatings;
    });
  }, [soundcastId]);

  return (
    <FlexDiv alignItems="center">
      <Toggle
        className="toggle-green"
        id="charging-status"
        aria-labelledby="charging-label"
        checked={displayRatings && !isPrivate}
        onChange={onChangeDisplayRating}
        disabled={isPrivate}
      />
      <span className="text-large font-weight-600 padding-left-10px">
        Display ratings on soundcast landing page
      </span>
    </FlexDiv>
  );
};

export default DisplayRatings;
